<!-- 接入指南 -->
<template>
    <div class="content">
        <ul>
            <li>
                <h3>业务说明</h3>
                <div>直接在微信公众号或者APP嵌入周边车场的链接,即可使用查找周边车场的功能</div>
            </li>
        </ul>
        <ul>
            <li>
                <h3>嵌入方法</h3>
                <div>直接在您的微信公众号/APP嵌入以下链接，其中{YOUR_KEY}是智慧停车开放平台分配给您的账号</div>
                <div>您需要提供一张1024*250的图片配置于授权商周边车场logo图片</div>
                <div>测试环境:<span class="url">{{ url.test }}/openydt/h5/aroudPark?key={YOUR_KEY}</span></div>
                <!-- <div>生产环境:<span class="url">{{ url.prod }}/openydt/h5/aroudPark?key={YOUR_KEY}</span></div> -->
            </li>
        </ul>
    </div>
</template>

<script>
  import { mapState } from "vuex";

export default {
    computed: {
      ...mapState(["url"])
    },

}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    h3 {
        margin: 0;
        padding: 10px 0 10px 0;
        font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
    .url{
        color:#4078c0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Doc/platform/other/h5/aroudPark.vue